// src/CommandModal.js
import React, { useState } from "react";
import { apiFetch } from "./api";

export default function CommandModal({ clientId, type, onClose, onSuccess }) {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  function label() {
    switch (type) {
      case "shell": return "Shell Command";
      case "download_file": return "File Path";
      case "zip_and_download": return "Folder Path";
      default: return "";
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await apiFetch("/issue_command", {
      method: "POST",
      body: JSON.stringify({
        client_id: clientId,
        type,
        data: data || undefined,
      }),
    });
    setLoading(false);
    if (res.status === "queued") {
      onSuccess();
    } else {
      setError(res.error || "Failed to issue command");
    }
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="close" onClick={onClose}>×</button>
        <h4>Issue Command: {type}</h4>
        <form onSubmit={handleSubmit}>
          {label() && (
            <input
              placeholder={label()}
              value={data}
              onChange={e => setData(e.target.value)}
              required
            />
          )}
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send"}
          </button>
        </form>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}
